import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserApi } from '../../api/UserApi';

const initialState = {
  data: [],
  authState: 'initial',
  details: {},
};

//To get logged in user details
export const getLoggedInUserDetails = createAsyncThunk(
  'userDetails/getLoggedInUserDetails',
  async (_action, thunkAPI) => {
    return UserApi.getLoggedInUserDetails(thunkAPI.dispatch);
  }
);

//Administration User management tab thunks
//To get paginated Users data
export const getUsers = createAsyncThunk(
  'administration/getUsers',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return UserApi.getUsers(action, thunkAPI.dispatch);
  }
);

//To create an user
export const createUser = createAsyncThunk(
  'userDetails/createUser',
  async (action: { request }, thunkAPI) => {
    return UserApi.createUser(action, thunkAPI.dispatch);
  }
);

//To update an user
export const updateUser = createAsyncThunk(
  'userDetails/updateUser',
  async (action: { request }, thunkAPI) => {
    return UserApi.updateUser(action, thunkAPI.dispatch);
  }
);

//To delete user
export const deleteUsers = createAsyncThunk(
  'userDetails/deleteUsers',
  async (action: { request }, thunkAPI) => {
    return UserApi.deleteUsers(action, thunkAPI.dispatch);
  }
);

//To update user role associations
export const updateUserRoleAssociation = createAsyncThunk(
  'userDetails/updateUserRoleAssociation',
  async (action: { request }, thunkAPI) => {
    return UserApi.updateUserRoleAssociation(action, thunkAPI.dispatch);
  }
);

//To get a user details
export const getUserDetails = createAsyncThunk(
  'userDetails/getUserDetails',
  async (action: { request }, thunkAPI) => {
    return UserApi.getUserDetails(action, thunkAPI.dispatch);
  }
);

const userSlice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    setAuthState(state, action) {
      state.authState = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLoggedInUserDetails.fulfilled, (state, action) => {
      if (!action.payload.error) {
        state.details = action.payload.data;
      }
    });
  },
});

export const { setAuthState } = userSlice.actions;

export const userSettings = (state) => state;

export default userSlice.reducer;
